let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5DW8N")).then(() => parcelRequire('8J7Hh'));